<template>
  <v-list-item three-line
    v-if="!isLoading"
    :class="{
      white: true,
      done: isComplete
    }">
    <v-list-item-avatar class="mt-6">
      <v-badge v-if="getReminderItems.length">
        <template v-slot:badge>
          <v-icon x-small color="white">fa-bell</v-icon>
        </template>
        <v-icon class="mt-4">{{ printCategoryIcon }}</v-icon>
      </v-badge>
      <v-icon v-else class="mt-4">{{ printCategoryIcon }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content class="pt-0">
      <v-list-item-subtitle>
        <v-row dense>
          <v-col cols="2" sm="1" class="pr-0 mt-2 overline">予定日</v-col>
          <v-col cols="7" sm="9">
            <v-chip-group show-arrows next-icon="fal fa-angle-right" prev-icon="fal fa-angle-left">
              <v-chip x-small color="amber">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ printScheduledDate }}</span>
                  </template>
                  <span>{{ printScheduledBy }}</span>
                </v-tooltip>
              </v-chip>
              <template v-for="item in getModifiedItems">
                <v-icon x-small :key="`${item.id}_arrow`" class="mr-2">fal fa-arrow-left</v-icon>
                <v-chip x-small :key="item.id">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.date }}</span>
                    </template>
                    <span>{{ item.by }}</span>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-chip-group>
          </v-col>
          <v-col cols="3" sm="2" class="text-right mt-2">
            <v-menu bottom left offset-y
              v-if="getAttachmentItems.length"
              :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <span v-on="on" class="overline">
                  <v-icon x-small class="mr-1">fal fa-paperclip</v-icon>{{ `添付 ${getAttachmentItems.length}件` }}
                </span>
              </template>
              <filer
                :items="getAttachmentItems"
                :showOnlyItems="true"
                :selectable="false"
                @preview="$set(config.filer, 'click', false)"
                @previewed="$set(config.filer, 'click', true)"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-list-item-subtitle>
      <v-list-item-title>
        <v-row dense>
          <v-col cols="11">{{ printTitle }}</v-col>
          <v-col cols="1" class="text-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">fal fa-info-circle</v-icon>
              </template>
              <span v-html="[].concat(isComplete ? [
                  `完了日：${printCompletedDate}`,
                  `完了者：${printCompletor}`
                ] : []).concat([
                  `作成日：${printCreatedDate}`,
                  `作成者：${printCreator}`,
                  `通知${getReminderItems.length ? `（${getReminderItems.length}）` : 'なし'}`
                ]).concat(getReminderItems.map(it => { return `・${it}` })).join('<br />')
              "/>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-list-item-title>
      <v-list-item-subtitle class="caption">
        <v-row dense>
          <v-col cols="8">
            <v-icon x-small class="mr-1 mb-1">fa-square</v-icon>
            <span>{{ printDescription }}</span>
          </v-col>
        </v-row>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="ml-2 mt-6">
      <v-menu bottom left offset-y :close-on-click="true">
        <template v-slot:activator="{ on }">
          <v-btn icon
            v-on="on"
            class="mt-3">
            <v-icon small color="secondary">fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>修正する</v-list-item-content>
          </v-list-item>
          <v-list-item @click="reschedule">
            <v-list-item-avatar>
              <v-icon small>fal fa-calendar-edit</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>日付を更新する</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isProgress" @click="complete">
            <v-list-item-avatar>
              <v-icon small>fal fa-check</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>完了する</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isComplete" @click="progress">
            <v-list-item-avatar>
              <v-icon small>fal fa-undo</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>未完する</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <Rescheduler ref="rescheduler"
      @done="submit"
    />
  </v-list-item>
  <v-skeleton-loader v-else-if="isSetItem" :key="item.id" type="list-item-avatar-two-line"></v-skeleton-loader>
  <v-list-item v-else>
    <v-list-item-content>アイテムがセットされていません</v-list-item-content>
  </v-list-item>
</template>
<script>
import filer from '@/components/filers/client'
import Rescheduler from './reschedule'
export default {
  name: 'clientEventsPoster',
  props: [
    'item'
  ],
  components: {
    filer,
    Rescheduler
  },
  data: () => ({
    config: {
      status: {
        loading: false
      }
    }
  }),
  methods: {
    edit: function () {
      this.$emit('emit', {
        action: 'edit',
        data: { id: this.$props.item.id }
      })
    },
    preSubmit: function (req) {
      const { type, eventDate } = req
      const { id } = this.$props.item
      const cid = this.$route.params.id
      const aid = this.$store.getters['author/get']('userid')
      const urls = {
        reschedule: `${this.$url.api}calendar/update/client/${cid}/${id}/date`,
        progress: `${this.$url.api}calendar/progress/client/${cid}/${id}`,
        complete: `${this.$url.api}calendar/complete/client/${cid}/${id}`
      }
      const fds = {
        reschedule: { aid, eventDate },
        progress: {},
        complete: { aid }
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'reschedule') {
        this.$set(this.config.status, 'loading', false)
        this.$emit('emit', {
          action: 'update',
          data: {
            type: 'update',
            data
          }
        })
      } else if (['progress', 'complete'].includes(type)) {
        // this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('emit', {
          action: 'update',
          data: {
            type: 'update',
            data
          }
        })
      } else if (type === 'update') {
        // this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', req)
      } else if (type === 'remove') {
        this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', req)
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'loading', false)
    },
    progress: function () {
      this.submit({ type: 'progress' })
    },
    complete: function () {
      this.submit({ type: 'complete' })
    },
    reschedule: function () {
      const { date, dateTime } = this.$props.item.start
      this.$refs.rescheduler.open({ date: date || dateTime })
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isSetItem () {
      return (this.$props.item && this.$props.item.id)
    },
    isProgress () {
      const { status } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return status === 'progress'
    },
    isComplete () {
      const { status } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return status === 'complete'
    },
    printCategoryIcon () {
      const { category } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return this.$mango.reminders[category] ? this.$mango.reminders[category].icon : 'fal fa-calendar-check'
    },
    printTitle () {
      const { category, label } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return `${category}: ${label}`
    },
    printScheduledDate () {
      return this.$props.item.scheduled || ''
    },
    printScheduledBy () {
      const authors = this.$store.getters['config/get']('authors')
      const { created_by, modified_by } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      const by = modified_by || created_by
      return authors[by] ? authors[by].name[0] : (by || '')
    },
    printDescription () {
      return this.$props.item.description || ''
    },
    printCreatedDate () {
      return this.$moment(this.$props.item.created || '').format('YYYY年MM月DD日')
    },
    printCreator () {
      const { created_by } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return created_by
    },
    printCompletedDate () {
      const { completed_at } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return this.$moment(completed_at || '').format('YYYY年MM月DD日')
    },
    printCompletor () {
      const { completed_by } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      return completed_by || ''
    },
    getModifiedItems () {
      const authors = this.$store.getters['config/get']('authors')
      const { log_at, log_by } = (this.$props.item.extendedProperties && this.$props.item.extendedProperties.private) ? this.$props.item.extendedProperties.private : {}
      const ats = log_at ? log_at.split(',') : []
      const bys = log_by ? log_by.split(',') : []
      return ats.length ? ats.map((at, i) => {
        return {
          id: this.$uuid(),
          date: this.$moment(at).format('YYYY年MM月DD日'),
          by: authors[bys[i]] ? authors[bys[i]].name[0] : (bys[i] || '')
        }
      }) : []
    },
    getReminderItems () {
      return this.$props.item.reminders.overrides ? this.$props.item.reminders.overrides.map(it => {
        if (it.minutes >= 10080) {
          return `${it.minutes / 10080}週前`
        } else if (it.minutes >= 1440) {
          return `${it.minutes / 1440}日前`
        } else {
          return `${it.minutes}分前`
        }
      }) : []
    },
    getAttachmentItems () {
      return this.$props.item.attachments || []
    }
  }
}
</script>

<style lang="scss" scoped>
.done {
  opacity: .3;
}
</style>